function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-100 -191)"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "m115.39 203.32a1.3192 1.1975 0 0 1-1.3192 1.1975 1.3192 1.1975 0 0 1-1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192 1.1975z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "m119.3 203.32a1.3192 1.1975 0 0 1-1.3192 1.1975 1.3192 1.1975 0 0 1-1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192 1.1975z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "m111.55 203.32a1.3192 1.1975 0 0 1-1.3192 1.1975 1.3192 1.1975 0 0 1-1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192-1.1975 1.3192 1.1975 0 0 1 1.3192 1.1975z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 114.07,
  cy: 203.45,
  rx: 7.4526,
  ry: 7.4866,
  fill: "none",
  strokeWidth: 0.918
}));

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11mm",
    height: "11mm",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#d5d5d5",
    stroke: "#d5d5d5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.74b18a6f.svg";
export { ForwardRef as ReactComponent };